import { render, staticRenderFns } from "./recommendGoodsManage.vue?vue&type=template&id=ff038712&scoped=true"
import script from "./recommendGoodsManage.vue?vue&type=script&lang=js"
export * from "./recommendGoodsManage.vue?vue&type=script&lang=js"
import style0 from "./recommendGoodsManage.vue?vue&type=style&index=0&id=ff038712&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff038712",
  null
  
)

export default component.exports